// /* global google */

// import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
// import * as XLSX from "xlsx";
// import {
//   Box,
//   Typography,
//   Button,
//   CircularProgress,
// } from "@mui/material";
// import MDButton from "components/MDButton";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
// import { GoogleMap, useJsApiLoader, Marker, InfoWindow, Polyline, OverlayView, Autocomplete } from "@react-google-maps/api";

// import stopMarker from "../../../../assets/marker_stop.png";
// import stopMyMarker from "../../../../assets/marker_my_stop.png";
// import stopGreenMarker from "../../../../assets/stop-marker.png";
// import rfidStopMarker from "../../../../assets/rfid-marker.png";
// import { v4 as uuidv4 } from "uuid";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";

// const mapContainerStyle = {
//   width: "100%",
//   height: "calc(100vh - 78px)",
//   borderRadius: '24px'
// };

// const GOOGLE_MAPS_LIBRARIES = ["geometry", "drawing", "places"];

// const useThrottledSnap = (polylinePath) => {
//   const frameRef = useRef(null);
//   const lastSnap = useRef(null);

//   const getSnap = useCallback(
//     (lat, lng) => {
//       if (!polylinePath || polylinePath.length < 2) return { lat, lng };

//       let minDist = Infinity;
//       let best = { lat, lng };

//       for (let i = 0; i < polylinePath.length - 1; i++) {
//         const a = polylinePath[i];
//         const b = polylinePath[i + 1];
//         const A = new window.google.maps.LatLng(a.lat, a.lng);
//         const B = new window.google.maps.LatLng(b.lat, b.lng);
//         const P = new window.google.maps.LatLng(lat, lng);

//         const proj = window.google.maps.geometry.spherical.interpolate(
//           A,
//           B,
//           Math.max(
//             0,
//             Math.min(
//               1,
//               ((window.google.maps.geometry.spherical.computeHeading(A, P) -
//                 window.google.maps.geometry.spherical.computeHeading(A, B) +
//                 360) %
//                 360) /
//               360
//             )
//           )
//         );

//         const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
//           P,
//           proj
//         );
//         if (dist < minDist) {
//           minDist = dist;
//           best = { lat: proj.lat(), lng: proj.lng() };
//         }
//       }
//       return best;
//     },
//     [polylinePath]
//   );

//   const throttled = useCallback(
//     (lat, lng, callback) => {
//       if (frameRef.current) return;
//       frameRef.current = requestAnimationFrame(() => {
//         const snap = getSnap(lat, lng);
//         lastSnap.current = snap;
//         callback(snap);
//         frameRef.current = null;
//       });
//     },
//     [getSnap]
//   );

//   useEffect(() => {
//     return () => {
//       if (frameRef.current) cancelAnimationFrame(frameRef.current);
//     };
//   }, []);

//   return { throttled, lastSnap: lastSnap.current };
// };



// const SnapPreview = React.memo(({ position }) => {
//   const pixel = useMemo(() => {
//     if (!position?.lat || !position?.lng) return null;
//     const projection = window.google.maps.maps_?.MapCanvasProjection;
//     if (!projection) return null;
//     const point = new window.google.maps.LatLng(position.lat, position.lng);
//     return projection.fromLatLngToDivPixel(point);
//   }, [position]);

//   if (!pixel) return null;

//   return (
//     <div
//       style={{
//         position: "absolute",
//         left: pixel.x - 8,
//         top: pixel.y - 8,
//         width: 16,
//         height: 16,
//         background: "rgba(0, 150, 255, 0.8)",
//         border: "2px solid white",
//         borderRadius: "50%",
//         pointerEvents: "none",
//         boxShadow: "0 0 8px rgba(0,0,0,0.4)",
//         zIndex: 1000,
//         transform: "translateZ(0)",
//       }}
//     />
//   );
// });

// const EditStopMap = ({
//   selectedJourney,
//   onBack,
//   tempJourney,
//   onJourneyUpdated,
//   hoveredStopId,
//   onClearJourney,
//   routeRange = [0, 100],
//   onSelectNewStop,
//   onStopUpdate,
// }) => {
//   const mapRef = useRef(null);
//   const [scriptLoaded, setScriptLoaded] = useState(false);
//   const [activeMarker, setActiveMarker] = useState(null);
//   const [tempMarker, setTempMarker] = useState(null);
//   const [autocomplete, setAutocomplete] = useState(null);
//   const [dragPreview, setDragPreview] = useState(null);
//   const [rfidData, setRfidData] = useState([]);
//   const [showRFID, setShowRFID] = useState(false);
//   const [activeRFID, setActiveRFID] = useState(null);

//   const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploadedStopsList, setUploadedStopsList] = useState(null);

//   const { data: journeysData = {} } = useSelector((state) => state.journey || {});
//   const tempData = journeysData.tempJourneys || [];
//   const mainData = journeysData.journeys || [];

//   // Route line (Polyline) ko nikalne ka sabse strong tareeqa:
//   const activePolyline = useMemo(() => {
//     const jMain = mainData.find(j => j.journeyId === selectedJourney?.journeyId);
//     const jTemp = tempData.find(j => j.journeyId === selectedJourney?.journeyId);

//     return selectedJourney?.wayPointsPolyLine
//       || tempJourney?.wayPointsPolyLine
//       || jMain?.wayPointsPolyLine
//       || jTemp?.wayPointsPolyLine;
//   }, [selectedJourney?.journeyId, mainData, tempData, selectedJourney?.wayPointsPolyLine, tempJourney?.wayPointsPolyLine]);

//   // Decode polylinePath using activePolyline
//   const polylinePath = useMemo(() => {
//     const encoded = activePolyline; // EnrichedJourney ki jagah activePolyline use kiya
//     if (!encoded) return [];

//     const points = [];
//     let index = 0, lat = 0, lng = 0;
//     while (index < encoded.length) {
//       let b, shift = 0, result = 0;
//       do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
//       const dlat = result & 1 ? ~(result >> 1) : result >> 1; lat += dlat;
//       shift = result = 0;
//       do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
//       const dlng = result & 1 ? ~(result >> 1) : result >> 1; lng += dlng;
//       points.push({ lat: lat / 1e5, lng: lng / 1e5 });
//     }
//     return points;
//   }, [activePolyline]);

//   const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyDv1tiSz3aXov0aqMcKu-OflzIIr9XK3mk",
//     libraries: GOOGLE_MAPS_LIBRARIES,
//   });

//   const onLoad = (autocompleteInstance) => {
//     setAutocomplete(autocompleteInstance);
//   };

//   // Jab user koi jagah select kare
//   const onPlaceChanged = () => {
//     if (autocomplete !== null) {
//       const place = autocomplete.getPlace();

//       if (place.geometry && place.geometry.location) {
//         const lat = place.geometry.location.lat();
//         const lng = place.geometry.location.lng();

//         // Map ko smoothly move karne ke liye
//         if (mapRef.current) {
//           mapRef.current.panTo({ lat, lng });
//           mapRef.current.setZoom(17);
//         }

//         // Agar aap chahte hain ki select karte hi marker temp dikhe
//         setTempMarker({ lat, lng });

//         toast.success(`Location found: ${place.name}`);
//       } else {
//         toast.error("No details available for this location.");
//       }
//     }
//   };

//   const handleSearchKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault(); // Page refresh hone se rokega
//       const query = e.target.value;
//       if (!query) return;

//       const geocoder = new window.google.maps.Geocoder();
//       geocoder.geocode({ address: query }, (results, status) => {
//         if (status === "OK" && results[0]) {
//           const location = results[0].geometry.location;
//           const lat = location.lat();
//           const lng = location.lng();

//           if (mapRef.current) {
//             mapRef.current.panTo({ lat, lng });
//             mapRef.current.setZoom(17);
//           }
//           setTempMarker({ lat, lng });
//           toast.success(`Location found: ${results[0].formatted_address}`);
//         } else {
//           toast.error("Could not find location for the entered text.");
//         }
//       });
//     }
//   };

//   // --- BULK UPLOAD LOGIC ---
//   const handleDownloadTemplate = () => {
//     // Naya format sirf 3 columns ke sath
//     const headers = ["Stop Name", "Latitude", "Longitude"];

//     // Sample data jisme 1st Source, last Destination, aur bich mein Stops hain
//     const sampleData = [
//       ["Source Point", "21.17697", "79.08936"],
//       ["ST 1", "21.17855", "79.09478"],
//       ["ST 2", "21.17309", "79.09974"],
//       ["Destination Point", "21.15465", "79.11520"]
//     ];

//     const csvContent = [
//       headers.join(","),
//       ...sampleData.map(row => row.join(","))
//     ].join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.setAttribute("href", url);
//     link.setAttribute("download", "Route_Stops_Template.csv");
//     link.click();
//   };

//   const createStopsData = (datas) => {
//     let journey = JSON.parse(JSON.stringify(enrichedJourney || {}));
//     let invalid = '';

//     if (!journey.filters) journey.filters = {};
//     if (!journey.stops) journey.stops = {};
//     if (!journey.sequence) journey.sequence = {};

//     datas.forEach((json, index) => {
//       const dataRow = index + 1;
//       const stopName = json['Stop Name'];
//       const admissionNoField = json['Admission No'];

//       if (!stopName) {
//         invalid += `Row ${dataRow}: Stop Name missing; `; return;
//       }

//       const filterId = uuidv4();
//       const lat = json['Latitude'] || '17.3850';
//       const lng = json['Longitude'] || '78.4867';

//       journey.filters[filterId] = {
//         filterId: filterId,
//         tags: [stopName, json['Landmark'] || ""],
//         type: "LocationFilter",
//         data: {
//           type: json['Stop Type'] || "BUS_STOP",
//           location: { latitude: parseFloat(lat), longitude: parseFloat(lng) }
//         },
//         adminOnly: false,
//         passengers: admissionNoField ? String(admissionNoField).split(',').length : 0,
//         selected: admissionNoField ? true : false,
//       };

//       if (admissionNoField) {
//         const admissionNos = String(admissionNoField).split(',').map(s => s.trim());
//         journey.stops[filterId] = admissionNos;
//       } else {
//         journey.stops[filterId] = [];
//       }

//       const seqSize = Object.keys(journey.sequence).length;
//       journey.sequence[seqSize] = filterId;
//     });

//     if (invalid.length > 0) {
//       toast.error(`Invalid data: ${invalid}`);
//       return null;
//     }
//     return journey;
//   };

//   const onUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       const data = event.target.result;
//       const workbook = XLSX.read(data, { type: 'binary' });
//       let dataStops = [];

//       workbook.SheetNames.forEach((sheetName) => {
//         const dataJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
//         if (sheetName === 'AddStops' || sheetName === 'Sheet1') {
//           dataStops = dataJson;
//         }
//       });

//       if (dataStops.length === 0 && workbook.SheetNames.length > 0) {
//         dataStops = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
//       }

//       // Excel se naye format me stops nikalna
//       const formattedStops = [];
//       let invalid = "";

//       dataStops.forEach((json, index) => {
//         const stopName = json['Stop Name'];
//         const lat = parseFloat(json['Latitude']);
//         const lng = parseFloat(json['Longitude']);

//         if (!stopName || isNaN(lat) || isNaN(lng)) {
//           invalid += `Row ${index + 2} invalid; `;
//         } else {
//           formattedStops.push({
//             stopName: stopName,
//             latitude: lat,
//             longitude: lng
//           });
//         }
//       });

//       if (invalid) {
//         toast.error(`Invalid data in file: ${invalid}`);
//         return;
//       }

//       // Minimum 2 stops validation
//       if (formattedStops.length < 2) {
//         toast.error("Minimum 2 stops (Source and Destination) are required in the file.");
//         return;
//       }

//       setUploadedStopsList(formattedStops);
//       setSelectedFile(file);
//       toast.success("File processed! Click 'Upload & Process' to generate route.");
//     };
//     reader.readAsBinaryString(file);
//   };

//   const handleUploadSubmit = async () => {
//     if (!uploadedStopsList || uploadedStopsList.length < 2) {
//       toast.error("Please upload a valid file with at least 2 rows (Source and Destination).");
//       return;
//     }

//     // 1. First row is Source (API format ke hisab se sirf lat/long chahiye)
//     const source = {
//       latitude: uploadedStopsList[0].latitude,
//       longitude: uploadedStopsList[0].longitude,
//     };

//     // 2. Last row is Destination
//     const destination = {
//       latitude: uploadedStopsList[uploadedStopsList.length - 1].latitude,
//       longitude: uploadedStopsList[uploadedStopsList.length - 1].longitude,
//     };

//     // 3. Middle rows are intermediate stops
//     // .slice(1, -1) ka matlab hai 1st aur last element chhodkar baaki sab le lo
//     const intermediateStops = uploadedStopsList.slice(1, -1).map(stop => ({
//       stopName: stop.stopName,
//       latitude: stop.latitude,
//       longitude: stop.longitude
//     }));

//     // 4. Exact Payload for the API
//     const payload = {
//       journeyId: selectedJourney.journeyId,
//       source: source,
//       destination: destination,
//       stops: intermediateStops
//     };

//     console.log("Final Payload going to API:", payload);

//     // 5. Nayi API ko hit karein
//     try {
//       const sessionToken = localStorage.getItem("token");
//       const response = await fetch("https://v3.dhundhoo.com/journey/updateJourneyStops", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-dhundhoo-session": sessionToken,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         const errText = await response.text();
//         throw new Error(`HTTP Error ${response.status}: ${errText}`);
//       }

//       const successMessage = await response.text();
//       console.log("Upload API Response:", successMessage);

//       toast.success("Route generated and stops uploaded successfully!");

//       // Modal band karein aur state clear karein
//       setIsUploadModalOpen(false);
//       setUploadedStopsList(null);
//       setSelectedFile(null);

//       // Parent component ko inform karein
//       if (onJourneyUpdated) onJourneyUpdated();

//     } catch (error) {
//       console.error("Upload & Generate Route Failed:", error);
//       toast.error(`Failed to generate route: ${error.message}`);
//     }
//   };

//   // Enriched journey: prefer tempData version
//   const enrichedJourney = useMemo(() => {
//     return selectedJourney || tempJourney;
//   }, [selectedJourney, tempJourney]);

//   // const polylinePath = useMemo(() => {
//   //   const encoded = enrichedJourney?.wayPointsPolyLine;
//   //   if (!encoded) return [];

//   //   const points = [];
//   //   let index = 0, lat = 0, lng = 0;
//   //   while (index < encoded.length) {
//   //     let b, shift = 0, result = 0;
//   //     do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
//   //     const dlat = result & 1 ? ~(result >> 1) : result >> 1; lat += dlat;
//   //     shift = result = 0;
//   //     do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
//   //     const dlng = result & 1 ? ~(result >> 1) : result >> 1; lng += dlng;
//   //     points.push({ lat: lat / 1e5, lng: lng / 1e5 });
//   //   }
//   //   return points;
//   // }, [enrichedJourney?.wayPointsPolyLine]);

//   const { throttled: snapThrottle } = useThrottledSnap(polylinePath);

//   const visiblePolylinePath = useMemo(() => {
//     if (!polylinePath || polylinePath.length === 0) return [];

//     const totalPoints = polylinePath.length;
//     // Percentage ko array index me convert karein
//     const startIndex = Math.floor((routeRange[0] / 100) * (totalPoints - 1));
//     const endIndex = Math.ceil((routeRange[1] / 100) * (totalPoints - 1));

//     // Sirf selected range wala route slice karke return karein
//     return polylinePath.slice(startIndex, endIndex + 1);
//   }, [polylinePath, routeRange]);

//   const validStops = useMemo(() => {
//     if (!enrichedJourney?.sequence || !enrichedJourney?.filters) return [];

//     return Object.entries(enrichedJourney.sequence).map(([_, filterId]) => {
//       const filter = enrichedJourney.filters[filterId];
//       if (!filter) return null;

//       const loc = filter?.data?.location || {};
//       const lat = loc.latitude;
//       const lng = loc.longitude;

//       if (lat != null && lng != null && !isNaN(lat) && !isNaN(lng)) {
//         return {
//           filterId,
//           name: filter?.tags?.[0] || "Unnamed",
//           landmark: filter?.tags?.[1] || "–",
//           lat: parseFloat(lat),
//           lng: parseFloat(lng),
//           passengerCount: Array.isArray(enrichedJourney.stops?.[filterId])
//             ? enrichedJourney.stops[filterId].length
//             : 0,
//         };
//       }
//       return null;
//     }).filter(Boolean);
//   }, [enrichedJourney?.sequence, enrichedJourney?.filters, enrichedJourney?.stops]);

//   const fitBoundsToContent = useCallback(() => {
//     if (!mapRef.current) return;
//     const bounds = new window.google.maps.LatLngBounds();

//     validStops.forEach((s) => bounds.extend(new window.google.maps.LatLng(s.lat, s.lng)));
//     polylinePath.forEach((p) => bounds.extend(new window.google.maps.LatLng(p.lat, p.lng)));

//     if (!bounds.isEmpty()) {
//       mapRef.current.fitBounds(bounds);
//       const listener = window.google.maps.event.addListener(mapRef.current, "idle", () => {
//         if (mapRef.current.getZoom() > 17) mapRef.current.setZoom(17);
//         window.google.maps.event.removeListener(listener);
//       });
//     }
//   }, [validStops, polylinePath]);

//   console.log("tempjourney", tempJourney);


//   useEffect(() => {
//     if (scriptLoaded && (validStops.length > 0 || polylinePath.length > 0)) {
//       fitBoundsToContent();
//     }
//   }, [scriptLoaded, validStops, polylinePath, fitBoundsToContent]);

//   // useEffect(() => {

//   //   console.log("Map received Hover ID:", hoveredStopId);
//   //   if (hoveredStopId && mapRef.current && validStops.length > 0) {
//   //     const stop = validStops.find(s => s.filterId === hoveredStopId);
//   //     console.log("Found stop in map:", stop);

//   //     if (stop && stop.lat && stop.lng) {
//   //       // Map ko smooth tarike se us stop par move karna
//   //       mapRef.current.panTo({ lat: stop.lat, lng: stop.lng });

//   //       // Us stop par zoom in karna
//   //       mapRef.current.setZoom(18); 

//   //     }
//   //   }
//   // }, [hoveredStopId, validStops]);

//   const handleMapRightClick = useCallback((e) => {
//     const lat = e.latLng.lat();
//     const lng = e.latLng.lng();
//     setTempMarker({ lat, lng });

//     const newStop = {
//       filterId: uuidv4(),
//       name: "New Stop",
//       type: "BUS_STOP",
//       latitude: lat,
//       longitude: lng,
//       data: { type: "BUS_STOP", location: { latitude: lat, longitude: lng } },
//       tags: ["New Stop", ""],
//       students: [],
//       isNew: true,
//     };

//     setTimeout(() => setTempMarker(null), 800);
//     onSelectNewStop(newStop);
//   }, [onSelectNewStop]);

//   const handleDrag = (filterId) => (e) => {
//     const lat = e.latLng.lat();
//     const lng = e.latLng.lng();
//     snapThrottle(lat, lng, (snap) => {
//       setDragPreview((prev) => (prev?.lat === snap.lat && prev?.lng === snap.lng ? prev : snap));
//     });
//   };

//   const handleDragEnd = (filterId) => (e) => {
//     const lat = e.latLng.lat();
//     const lng = e.latLng.lng();
//     const finalSnap = polylinePath.length > 0
//       ? nearestPoint(polylinePath, lat, lng)
//       : { lat, lng };

//     if (onStopUpdate) {
//       // 4th parameter mein 'activePolyline' pass kar rahe hain
//       onStopUpdate(filterId, finalSnap.lat, finalSnap.lng, activePolyline);
//     }
//     setDragPreview(null);
//   };

//   const nearestPoint = (path, lat, lng) => {
//     let min = Infinity, best = { lat, lng };
//     for (let i = 0; i < path.length - 1; i++) {
//       const a = path[i], b = path[i + 1];
//       const proj = projectPointOnSegment(a, b, { lat, lng });
//       const d = distance(proj, { lat, lng });
//       if (d < min) { min = d; best = proj; }
//     }
//     return best;
//   };

//   const projectPointOnSegment = (a, b, p) => {
//     const x1 = a.lng, y1 = a.lat, x2 = b.lng, y2 = b.lat, x0 = p.lng, y0 = p.lat;
//     const dx = x2 - x1, dy = y2 - y1;
//     let t = ((x0 - x1) * dx + (y0 - y1) * dy) / (dx * dx + dy * dy);
//     t = Math.max(0, Math.min(1, t));
//     return { lat: y1 + t * dy, lng: x1 + t * dx };
//   };

//   const distance = (a, b) => {
//     const dx = a.lng - b.lng, dy = a.lat - b.lat;
//     return dx * dx + dy * dy;
//   };

//   const fetchRFIDData = async () => {
//     try {
//       // 1. Aaj ki date nikalna (YYYY/MM/DD format mein)
//       const today = new Date().toISOString().split('T')[0].replace(/-/g, '/');

//       // 2. Journey se time nikalna (Fallback 00:00 aur 23:59 agar interval na mile)
//       const journeyStartTime = selectedJourney?.interval?.startTime || "00:00";
//       const journeyEndTime = selectedJourney?.interval?.endTime || "23:59";

//       const payload = {
//         // Aaj ki date + Journey ka actual time merge kar rahe hain
//         startTime: `${today} ${journeyStartTime}`,
//         endTime: `${today} ${journeyEndTime}`,
//         thingIds: [selectedJourney.thingId],
//         timeZone: "Asia/Kolkata"
//       };

//       console.log("RFID Request Payload:", payload); // Debugging ke liye check kar sakte hain

//       const response = await fetch("https://v3.dhundhoo.com/reports/reports/access", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-dhundhoo-session": localStorage.getItem("token"),
//         },
//         body: JSON.stringify(payload),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setRfidData(data.rowList || []);
//       } else {
//         toast.error("Failed to fetch RFID data");
//       }
//     } catch (error) {
//       console.error("RFID Fetch Error:", error);
//       toast.error("Error connecting to RFID service");
//     }
//   };

//   // Jab Checkbox toggle ho tab API call karein
//   const handleToggleRFID = (e) => {
//     const checked = e.target.checked;
//     setShowRFID(checked);
//     if (checked && rfidData.length === 0) {
//       fetchRFIDData();
//     }
//   };

//   // if (validStops.length === 0 && polylinePath.length === 0) {
//   //   return (
//   //     <Box sx={{ p: 2, textAlign: "center" }}>
//   //       <Typography variant="h6" color="text.secondary">
//   //         No route or stops to display.
//   //       </Typography>
//   //       <Button variant="contained" onClick={onBack} sx={{ mt: 2 }}>
//   //         Back
//   //       </Button>
//   //     </Box>
//   //   );
//   // }

//   return (
//     <Box sx={{ p: 2, position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
//       {isLoaded && (
//         <>

//           <Box sx={{
//             position: "absolute",
//             top: "25px",
//             right: "80px",
//             // zIndex: 10,
//             zIndex: 1000,
//             width: "350px"
//           }}>
//             <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
//               {/* <input
//                 type="text"
//                 placeholder="Search location..."
//                 style={{
//                   boxSizing: `border-box`,
//                   border: `1px solid transparent`,
//                   width: `100%`,
//                   height: `40px`,
//                   padding: `0 12px`,
//                   borderRadius: `3px`,
//                   boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
//                   fontSize: `14px`,
//                   outline: `none`,
//                   textOverflow: `ellipses`,
//                 }}
//               /> */}
//               <Box
//                 component="input"
//                 placeholder="Search location..."
//                 onKeyDown={handleSearchKeyDown}
//                 sx={{
//                   boxSizing: `border-box`,
//                   border: `1px solid #e0e0e0`,
//                   width: `100%`,
//                   height: `43px`,
//                   padding: `0 12px`,
//                   borderRadius: `4px`,
//                   boxShadow: `0 2px 6px rgba(0, 0, 0, 0.1)`,
//                   fontSize: `14px`,
//                   outline: `none`,
//                   textOverflow: `ellipses`,
//                   // Placeholder color yahan se control hoga
//                   "&::placeholder": {
//                     color: "rgba(73, 72, 72, 0.4)", // Light color
//                     fontWeight: 400
//                   }
//                 }}
//               />
//             </Autocomplete>
//           </Box>
//           <Box sx={{ position: "absolute", top: "25px", left: "180px", zIndex: 1000, bgcolor: '#fff', p: 1, borderRadius: 2, boxShadow: 3 }}>
//             <label style={{ fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
//               <input type="checkbox" checked={showRFID} onChange={handleToggleRFID} style={{ marginRight: '8px' }} />
//               Show RFID
//             </label>
//           </Box>
//           <Box sx={{ position: "absolute", top: "25px", left: "25px", zIndex: 1000 }}>
//             <MDButton
//               variant="contained"
//               color="warning"
//               onClick={() => setIsUploadModalOpen(true)}
//               sx={{ color: '#fff', boxShadow: '0 2px 6px rgba(0,0,0,0.3)' }}
//             >
//               Upload Stops
//             </MDButton>
//           </Box>
//           <GoogleMap
//             mapContainerStyle={mapContainerStyle}
//             onLoad={(map) => {
//               mapRef.current = map;
//               fitBoundsToContent();
//             }}
//             center={validStops.length > 0 ? undefined : { lat: 17.3850, lng: 78.4867 }}
//             // zoom={10}
//             zoom={validStops.length > 0 ? undefined : 12}
//             onRightClick={handleMapRightClick}
//             options={{
//               streetViewControl: false,
//               mapTypeControl: false,
//               fullscreenControl: true, // Yeh option button dikhayega
//               fullscreenControlOptions: {
//                 position: window.google.maps.ControlPosition.RIGHT_TOP, // Button ki jagah
//               },
//               zoomControl: true,
//               gestureHandling: "greedy",
//             }}
//           >
//             {visiblePolylinePath.length > 0 && (
//               <Polyline
//                 path={visiblePolylinePath}
//                 options={{
//                   strokeColor: "black",
//                   strokeOpacity: 0.8,
//                   strokeWeight: 4,
//                 }}
//               />
//             )}

//             {/* {validStops.map((stop) => {
//               const isPending = selectedJourney?.state === "INITIALIZED" && !activePolyline;
//               // const isPending = selectedJourney?.state === "INITIALIZED" && !selectedJourney?.wayPointsPolyLine;

//               const markerIcon = isPending
//                 ? stopMyMarker
//                 : stopMarker; // Default for normal

//               return (

//                 <Marker
//                   key={stop.filterId}
//                   position={{ lat: stop.lat, lng: stop.lng }}
//                   draggable
//                   onDrag={handleDrag(stop.filterId)}
//                   onDragEnd={handleDragEnd(stop.filterId)}
//                   title={stop.name}
//                   onClick={() => setActiveMarker(stop.filterId)}
//                   icon={{
//                     url: markerIcon,
//                     scaledSize: new window.google.maps.Size(40, 40),
//                   }}
//                 > */}
//             {validStops.map((stop) => {
//               const isPending = selectedJourney?.state === "INITIALIZED" && !activePolyline;
//               const markerIcon = isPending ? stopMyMarker : stopMarker;

//               // 1. CHECK KAREIN KI KYA YE HOVERED STOP HAI
//               const isHovered = hoveredStopId === stop.filterId;

//               // 2. HOVER HONE PAR SIZE BADA KAREIN (Normal: 40, Hover: 65)
//               const markerSize = isHovered ? 40 : 30;

//               return (
//                 <Marker
//                   key={stop.filterId}
//                   position={{ lat: stop.lat, lng: stop.lng }}
//                   draggable
//                   onDrag={handleDrag(stop.filterId)}
//                   onDragEnd={handleDragEnd(stop.filterId)}
//                   title={stop.name}
//                   onClick={() => setActiveMarker(stop.filterId)}
//                   icon={{
//                     url: markerIcon,
//                     // 3. YAHAN DYNAMIC SIZE PASS KAREIN
//                     scaledSize: new window.google.maps.Size(markerSize, markerSize),
//                   }}
//                   // 4. HOVER HONE PAR Z-INDEX BADHA DEIN TAAKI MARKER UPAR DIKHE
//                   zIndex={isHovered ? 1000 : 1}
//                 >
//                   {activeMarker === stop.filterId && (
//                     <InfoWindow onCloseClick={() => setActiveMarker(null)}>
//                       <div style={{ maxWidth: 220 }}>
//                         <Typography variant="subtitle2">{stop.name}</Typography>
//                         <Typography variant="caption" display="block">
//                           Landmark: {stop.landmark}
//                         </Typography>
//                         <Typography variant="caption">
//                           Passengers: {stop.passengerCount}
//                         </Typography>
//                       </div>
//                     </InfoWindow>
//                   )}
//                 </Marker>
//               )
//             })}

//             {dragPreview && dragPreview.lat != null && dragPreview.lng != null && (
//               <OverlayView
//                 position={dragPreview}
//                 mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
//               >
//                 <SnapPreview position={dragPreview} />
//               </OverlayView>
//             )}

//             {tempMarker && (
//               <Marker
//                 position={tempMarker}
//                 icon={{
//                   url: stopGreenMarker,
//                   scaledSize: new window.google.maps.Size(40, 40),
//                 }}
//                 opacity={0.8}
//               // animation={window.google.maps.Animation.BOUNCE}
//               />
//             )}

//             {/* --- NEW: RFID MARKERS --- */}
//             {showRFID && rfidData.map((item, index) => (
//               <Marker
//                 key={`rfid-${index}`}
//                 position={{ lat: Number(item.latitude), lng: Number(item.longitude) }}
//                 onClick={() => setActiveRFID(item)}
//                 icon={{
//                   url: rfidStopMarker, // Ya aapka customized @parking icon
//                   scaledSize: new window.google.maps.Size(35, 35),
//                 }}
//               >
//                 {activeRFID === item && (
//                   <InfoWindow onCloseClick={() => setActiveRFID(null)}>
//                     <div style={{ color: '#000' }}>
//                       <Typography variant="subtitle2">{item.accountName || "Unknown"}</Typography>
//                       <Typography variant="caption">Time: {item.accessTime}</Typography><br />
//                       <Typography variant="caption">ID: {item.accessId}</Typography>
//                     </div>
//                   </InfoWindow>
//                 )}
//               </Marker>
//             ))}
//           </GoogleMap>

//           {/* 4. YAHAN AAYEGA MODAL (DIALOG) JISMEIN UPLOAD & PROCESS BUTTON HAI */}
//           <Dialog open={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} maxWidth="sm" fullWidth>
//             <DialogTitle>Bulk Upload Stops to Map</DialogTitle>

//             <DialogContent>
//               <Box p={2}>
//                 <Typography variant="body2" mb={2}>
//                   Download the template, add your stops with Latitude and Longitude, and upload it back.
//                 </Typography>

//                 <Button variant="contained" color="info" fullWidth onClick={handleDownloadTemplate} sx={{ mb: 3 }}>
//                   Download Template (CSV)
//                 </Button>

//                 {selectedFile && (
//                   <Typography variant="caption" color="success.main" sx={{ mt: 1, mb: 1, display: "block" }}>
//                     Selected: {selectedFile.name}
//                   </Typography>
//                 )}

//                 <input
//                   type="file"
//                   accept=".xlsx, .xls, .csv"
//                   onChange={onUpload}
//                   style={{ width: "100%", padding: "10px", border: "1px dashed #ccc", borderRadius: "4px" }}
//                 />
//               </Box>
//             </DialogContent>

//             {/* YEH HAI WOH JAGAH JAHAN BUTTON DALNA HAI */}
//             <DialogActions>
//               <Button onClick={() => setIsUploadModalOpen(false)} color="inherit">
//                 Cancel
//               </Button>

//               {/* YAHAN DALNA HAI YEH BUTTON */}
//               <Button
//                 onClick={handleUploadSubmit}
//                 variant="contained"
//                 color="info"
//                 disabled={!uploadedStopsList}
//               >
//                 Upload & Process
//               </Button>

//             </DialogActions>
//           </Dialog>
//         </>
//       )}
//     </Box>
//   );
// };

// export default EditStopMap;

/* global google */

import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import * as XLSX from "xlsx";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import MDButton from "components/MDButton";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { GoogleMap, useJsApiLoader, Marker, InfoWindow, Polyline, OverlayView, Autocomplete } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from "config/apis";

import stopMarker from "../../../../assets/marker_stop.png";
import stopMyMarker from "../../../../assets/marker_my_stop.png";
import stopGreenMarker from "../../../../assets/stop-marker.png";
import rfidStopMarker from "../../../../assets/rfid-marker.png";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const mapContainerStyle = {
  width: "100%",
  height: "calc(100vh - 78px)",
  borderRadius: '24px'
};

const useThrottledSnap = (polylinePath) => {
  const frameRef = useRef(null);
  const lastSnap = useRef(null);

  const getSnap = useCallback(
    (lat, lng) => {
      if (!polylinePath || polylinePath.length < 2) return { lat, lng };

      let minDist = Infinity;
      let best = { lat, lng };

      for (let i = 0; i < polylinePath.length - 1; i++) {
        const a = polylinePath[i];
        const b = polylinePath[i + 1];
        const A = new window.google.maps.LatLng(a.lat, a.lng);
        const B = new window.google.maps.LatLng(b.lat, b.lng);
        const P = new window.google.maps.LatLng(lat, lng);

        const proj = window.google.maps.geometry.spherical.interpolate(
          A,
          B,
          Math.max(
            0,
            Math.min(
              1,
              ((window.google.maps.geometry.spherical.computeHeading(A, P) -
                window.google.maps.geometry.spherical.computeHeading(A, B) +
                360) %
                360) /
              360
            )
          )
        );

        const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
          P,
          proj
        );
        if (dist < minDist) {
          minDist = dist;
          best = { lat: proj.lat(), lng: proj.lng() };
        }
      }
      return best;
    },
    [polylinePath]
  );

  const throttled = useCallback(
    (lat, lng, callback) => {
      if (frameRef.current) return;
      frameRef.current = requestAnimationFrame(() => {
        const snap = getSnap(lat, lng);
        lastSnap.current = snap;
        callback(snap);
        frameRef.current = null;
      });
    },
    [getSnap]
  );

  useEffect(() => {
    return () => {
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, []);

  return { throttled, lastSnap: lastSnap.current };
};



const SnapPreview = React.memo(({ position }) => {
  const pixel = useMemo(() => {
    if (!position?.lat || !position?.lng) return null;
    const projection = window.google.maps.maps_?.MapCanvasProjection;
    if (!projection) return null;
    const point = new window.google.maps.LatLng(position.lat, position.lng);
    return projection.fromLatLngToDivPixel(point);
  }, [position]);

  if (!pixel) return null;

  return (
    <div
      style={{
        position: "absolute",
        left: pixel.x - 8,
        top: pixel.y - 8,
        width: 16,
        height: 16,
        background: "rgba(0, 150, 255, 0.8)",
        border: "2px solid white",
        borderRadius: "50%",
        pointerEvents: "none",
        boxShadow: "0 0 8px rgba(0,0,0,0.4)",
        zIndex: 1000,
        transform: "translateZ(0)",
      }}
    />
  );
});

const EditStopMap = ({
  selectedJourney,
  onBack,
  tempJourney,
  onJourneyUpdated,
  hoveredStopId,
  onClearJourney,
  routeRange = [0, 100],
  onSelectNewStop,
  onStopUpdate,
}) => {
  const mapRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [activeMarker, setActiveMarker] = useState(null);
  const [tempMarker, setTempMarker] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [dragPreview, setDragPreview] = useState(null);
  const [rfidData, setRfidData] = useState([]);
  const [showRFID, setShowRFID] = useState(false);
  const [activeRFID, setActiveRFID] = useState(null);

  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedStopsList, setUploadedStopsList] = useState(null);

  const { data: journeysData = {} } = useSelector((state) => state.journey || {});
  const tempData = journeysData.tempJourneys || [];
  const mainData = journeysData.journeys || [];

  // Route line (Polyline) ko nikalne ka sabse strong tareeqa:
  const activePolyline = useMemo(() => {
    const jMain = mainData.find(j => j.journeyId === selectedJourney?.journeyId);
    const jTemp = tempData.find(j => j.journeyId === selectedJourney?.journeyId);

    return selectedJourney?.wayPointsPolyLine
      || tempJourney?.wayPointsPolyLine
      || jMain?.wayPointsPolyLine
      || jTemp?.wayPointsPolyLine;
  }, [selectedJourney?.journeyId, mainData, tempData, selectedJourney?.wayPointsPolyLine, tempJourney?.wayPointsPolyLine]);

  // Decode polylinePath using activePolyline
  const polylinePath = useMemo(() => {
    const encoded = activePolyline; // EnrichedJourney ki jagah activePolyline use kiya
    if (!encoded) return [];

    const points = [];
    let index = 0, lat = 0, lng = 0;
    while (index < encoded.length) {
      let b, shift = 0, result = 0;
      do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
      const dlat = result & 1 ? ~(result >> 1) : result >> 1; lat += dlat;
      shift = result = 0;
      do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
      const dlng = result & 1 ? ~(result >> 1) : result >> 1; lng += dlng;
      points.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return points;
  }, [activePolyline]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  // Jab user koi jagah select kare
  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();

      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        // Map ko smoothly move karne ke liye
        if (mapRef.current) {
          mapRef.current.panTo({ lat, lng });
          mapRef.current.setZoom(17);
        }

        // Agar aap chahte hain ki select karte hi marker temp dikhe
        setTempMarker({ lat, lng });

        toast.success(`Location found: ${place.name}`);
      } else {
        toast.error("No details available for this location.");
      }
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Page refresh hone se rokega
      const query = e.target.value;
      if (!query) return;

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: query }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          const lat = location.lat();
          const lng = location.lng();

          if (mapRef.current) {
            mapRef.current.panTo({ lat, lng });
            mapRef.current.setZoom(17);
          }
          setTempMarker({ lat, lng });
          toast.success(`Location found: ${results[0].formatted_address}`);
        } else {
          toast.error("Could not find location for the entered text.");
        }
      });
    }
  };

  // --- BULK UPLOAD LOGIC ---
  const handleDownloadTemplate = () => {
    // Naya format sirf 3 columns ke sath
    const headers = ["Stop Name", "Latitude", "Longitude"];

    // Sample data jisme 1st Source, last Destination, aur bich mein Stops hain
    const sampleData = [
      ["Source Point", "21.17697", "79.08936"],
      ["ST 1", "21.17855", "79.09478"],
      ["ST 2", "21.17309", "79.09974"],
      ["Destination Point", "21.15465", "79.11520"]
    ];

    const csvContent = [
      headers.join(","),
      ...sampleData.map(row => row.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Route_Stops_Template.csv");
    link.click();
  };

  const createStopsData = (datas) => {
    let journey = JSON.parse(JSON.stringify(enrichedJourney || {}));
    let invalid = '';

    if (!journey.filters) journey.filters = {};
    if (!journey.stops) journey.stops = {};
    if (!journey.sequence) journey.sequence = {};

    datas.forEach((json, index) => {
      const dataRow = index + 1;
      const stopName = json['Stop Name'];
      const admissionNoField = json['Admission No'];

      if (!stopName) {
        invalid += `Row ${dataRow}: Stop Name missing; `; return;
      }

      const filterId = uuidv4();
      const lat = json['Latitude'] || '17.3850';
      const lng = json['Longitude'] || '78.4867';

      journey.filters[filterId] = {
        filterId: filterId,
        tags: [stopName, json['Landmark'] || ""],
        type: "LocationFilter",
        data: {
          type: json['Stop Type'] || "BUS_STOP",
          location: { latitude: parseFloat(lat), longitude: parseFloat(lng) }
        },
        adminOnly: false,
        passengers: admissionNoField ? String(admissionNoField).split(',').length : 0,
        selected: admissionNoField ? true : false,
      };

      if (admissionNoField) {
        const admissionNos = String(admissionNoField).split(',').map(s => s.trim());
        journey.stops[filterId] = admissionNos;
      } else {
        journey.stops[filterId] = [];
      }

      const seqSize = Object.keys(journey.sequence).length;
      journey.sequence[seqSize] = filterId;
    });

    if (invalid.length > 0) {
      toast.error(`Invalid data: ${invalid}`);
      return null;
    }
    return journey;
  };

  const onUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = event.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      let dataStops = [];

      workbook.SheetNames.forEach((sheetName) => {
        const dataJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        if (sheetName === 'AddStops' || sheetName === 'Sheet1') {
          dataStops = dataJson;
        }
      });

      if (dataStops.length === 0 && workbook.SheetNames.length > 0) {
        dataStops = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      }

      // Excel se naye format me stops nikalna
      const formattedStops = [];
      let invalid = "";

      dataStops.forEach((json, index) => {
        const stopName = json['Stop Name'];
        const lat = parseFloat(json['Latitude']);
        const lng = parseFloat(json['Longitude']);

        if (!stopName || isNaN(lat) || isNaN(lng)) {
          invalid += `Row ${index + 2} invalid; `;
        } else {
          formattedStops.push({
            stopName: stopName,
            latitude: lat,
            longitude: lng
          });
        }
      });

      if (invalid) {
        toast.error(`Invalid data in file: ${invalid}`);
        return;
      }

      // Minimum 2 stops validation
      if (formattedStops.length < 2) {
        toast.error("Minimum 2 stops (Source and Destination) are required in the file.");
        return;
      }

      setUploadedStopsList(formattedStops);
      setSelectedFile(file);
      toast.success("File processed! Click 'Upload & Process' to generate route.");
    };
    reader.readAsBinaryString(file);
  };

  const handleUploadSubmit = async () => {
    if (!uploadedStopsList || uploadedStopsList.length < 2) {
      toast.error("Please upload a valid file with at least 2 rows (Source and Destination).");
      return;
    }

    // 1. First row is Source (API format ke hisab se sirf lat/long chahiye)
    const source = {
      latitude: uploadedStopsList[0].latitude,
      longitude: uploadedStopsList[0].longitude,
    };

    // 2. Last row is Destination
    const destination = {
      latitude: uploadedStopsList[uploadedStopsList.length - 1].latitude,
      longitude: uploadedStopsList[uploadedStopsList.length - 1].longitude,
    };

    // 3. Middle rows are intermediate stops
    // .slice(1, -1) ka matlab hai 1st aur last element chhodkar baaki sab le lo
    const intermediateStops = uploadedStopsList.slice(1, -1).map(stop => ({
      stopName: stop.stopName,
      latitude: stop.latitude,
      longitude: stop.longitude
    }));

    // 4. Exact Payload for the API
    const payload = {
      journeyId: selectedJourney.journeyId,
      source: source,
      destination: destination,
      stops: intermediateStops
    };

    console.log("Final Payload going to API:", payload);

    // 5. Nayi API ko hit karein
    try {
      const sessionToken = localStorage.getItem("token");
      const response = await fetch("https://v3.dhundhoo.com/journey/updateJourneyStops", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-dhundhoo-session": sessionToken,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errText = await response.text();
        throw new Error(`HTTP Error ${response.status}: ${errText}`);
      }

      const successMessage = await response.text();
      console.log("Upload API Response:", successMessage);

      toast.success("Route generated and stops uploaded successfully!");

      // Modal band karein aur state clear karein
      setIsUploadModalOpen(false);
      setUploadedStopsList(null);
      setSelectedFile(null);

      // Parent component ko inform karein
      if (onJourneyUpdated) onJourneyUpdated();

    } catch (error) {
      console.error("Upload & Generate Route Failed:", error);
      toast.error(`Failed to generate route: ${error.message}`);
    }
  };

  // Enriched journey: prefer tempData version
  const enrichedJourney = useMemo(() => {
    return selectedJourney || tempJourney;
  }, [selectedJourney, tempJourney]);

  // const polylinePath = useMemo(() => {
  //   const encoded = enrichedJourney?.wayPointsPolyLine;
  //   if (!encoded) return [];

  //   const points = [];
  //   let index = 0, lat = 0, lng = 0;
  //   while (index < encoded.length) {
  //     let b, shift = 0, result = 0;
  //     do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
  //     const dlat = result & 1 ? ~(result >> 1) : result >> 1; lat += dlat;
  //     shift = result = 0;
  //     do { b = encoded.charCodeAt(index++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
  //     const dlng = result & 1 ? ~(result >> 1) : result >> 1; lng += dlng;
  //     points.push({ lat: lat / 1e5, lng: lng / 1e5 });
  //   }
  //   return points;
  // }, [enrichedJourney?.wayPointsPolyLine]);

  const { throttled: snapThrottle } = useThrottledSnap(polylinePath);

  const visiblePolylinePath = useMemo(() => {
    if (!polylinePath || polylinePath.length === 0) return [];

    const totalPoints = polylinePath.length;
    // Percentage ko array index me convert karein
    const startIndex = Math.floor((routeRange[0] / 100) * (totalPoints - 1));
    const endIndex = Math.ceil((routeRange[1] / 100) * (totalPoints - 1));

    // Sirf selected range wala route slice karke return karein
    return polylinePath.slice(startIndex, endIndex + 1);
  }, [polylinePath, routeRange]);

  const validStops = useMemo(() => {
    if (!enrichedJourney?.sequence || !enrichedJourney?.filters) return [];

    return Object.entries(enrichedJourney.sequence).map(([_, filterId]) => {
      const filter = enrichedJourney.filters[filterId];
      if (!filter) return null;

      const loc = filter?.data?.location || {};
      const lat = loc.latitude;
      const lng = loc.longitude;

      if (lat != null && lng != null && !isNaN(lat) && !isNaN(lng)) {
        return {
          filterId,
          name: filter?.tags?.[0] || "Unnamed",
          landmark: filter?.tags?.[1] || "–",
          lat: parseFloat(lat),
          lng: parseFloat(lng),
          passengerCount: Array.isArray(enrichedJourney.stops?.[filterId])
            ? enrichedJourney.stops[filterId].length
            : 0,
        };
      }
      return null;
    }).filter(Boolean);
  }, [enrichedJourney?.sequence, enrichedJourney?.filters, enrichedJourney?.stops]);

  const fitBoundsToContent = useCallback(() => {
    if (!mapRef.current) return;
    const bounds = new window.google.maps.LatLngBounds();

    validStops.forEach((s) => bounds.extend(new window.google.maps.LatLng(s.lat, s.lng)));
    polylinePath.forEach((p) => bounds.extend(new window.google.maps.LatLng(p.lat, p.lng)));

    if (!bounds.isEmpty()) {
      mapRef.current.fitBounds(bounds);
      const listener = window.google.maps.event.addListener(mapRef.current, "idle", () => {
        if (mapRef.current.getZoom() > 17) mapRef.current.setZoom(17);
        window.google.maps.event.removeListener(listener);
      });
    }
  }, [validStops, polylinePath]);

  console.log("tempjourney", tempJourney);


  useEffect(() => {
    if (scriptLoaded && (validStops.length > 0 || polylinePath.length > 0)) {
      fitBoundsToContent();
    }
  }, [scriptLoaded, validStops, polylinePath, fitBoundsToContent]);

  // useEffect(() => {

  //   console.log("Map received Hover ID:", hoveredStopId);
  //   if (hoveredStopId && mapRef.current && validStops.length > 0) {
  //     const stop = validStops.find(s => s.filterId === hoveredStopId);
  //     console.log("Found stop in map:", stop);

  //     if (stop && stop.lat && stop.lng) {
  //       // Map ko smooth tarike se us stop par move karna
  //       mapRef.current.panTo({ lat: stop.lat, lng: stop.lng });

  //       // Us stop par zoom in karna
  //       mapRef.current.setZoom(18); 

  //     }
  //   }
  // }, [hoveredStopId, validStops]);

  const handleMapRightClick = useCallback((e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setTempMarker({ lat, lng });

    const newStop = {
      filterId: uuidv4(),
      name: "New Stop",
      type: "BUS_STOP",
      latitude: lat,
      longitude: lng,
      data: { type: "BUS_STOP", location: { latitude: lat, longitude: lng } },
      tags: ["New Stop", ""],
      students: [],
      isNew: true,
    };

    setTimeout(() => setTempMarker(null), 800);
    onSelectNewStop(newStop);
  }, [onSelectNewStop]);

  const handleDrag = (filterId) => (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    snapThrottle(lat, lng, (snap) => {
      setDragPreview((prev) => (prev?.lat === snap.lat && prev?.lng === snap.lng ? prev : snap));
    });
  };

  const handleDragEnd = (filterId) => (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const finalSnap = polylinePath.length > 0
      ? nearestPoint(polylinePath, lat, lng)
      : { lat, lng };

    if (onStopUpdate) {
      // 4th parameter mein 'activePolyline' pass kar rahe hain
      onStopUpdate(filterId, finalSnap.lat, finalSnap.lng, activePolyline);
    }
    setDragPreview(null);
  };

  const nearestPoint = (path, lat, lng) => {
    let min = Infinity, best = { lat, lng };
    for (let i = 0; i < path.length - 1; i++) {
      const a = path[i], b = path[i + 1];
      const proj = projectPointOnSegment(a, b, { lat, lng });
      const d = distance(proj, { lat, lng });
      if (d < min) { min = d; best = proj; }
    }
    return best;
  };

  const projectPointOnSegment = (a, b, p) => {
    const x1 = a.lng, y1 = a.lat, x2 = b.lng, y2 = b.lat, x0 = p.lng, y0 = p.lat;
    const dx = x2 - x1, dy = y2 - y1;
    let t = ((x0 - x1) * dx + (y0 - y1) * dy) / (dx * dx + dy * dy);
    t = Math.max(0, Math.min(1, t));
    return { lat: y1 + t * dy, lng: x1 + t * dx };
  };

  const distance = (a, b) => {
    const dx = a.lng - b.lng, dy = a.lat - b.lat;
    return dx * dx + dy * dy;
  };

  const fetchRFIDData = async () => {
    try {
      // 1. Aaj ki date nikalna (YYYY/MM/DD format mein)
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '/');

      // 2. Journey se time nikalna (Fallback 00:00 aur 23:59 agar interval na mile)
      const journeyStartTime = selectedJourney?.interval?.startTime || "00:00";
      const journeyEndTime = selectedJourney?.interval?.endTime || "23:59";

      const payload = {
        // Aaj ki date + Journey ka actual time merge kar rahe hain
        startTime: `${today} ${journeyStartTime}`,
        endTime: `${today} ${journeyEndTime}`,
        thingIds: [selectedJourney.thingId],
        timeZone: "Asia/Kolkata"
      };

      console.log("RFID Request Payload:", payload); // Debugging ke liye check kar sakte hain

      const response = await fetch("https://v3.dhundhoo.com/reports/reports/access", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-dhundhoo-session": localStorage.getItem("token"),
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        setRfidData(data.rowList || []);
      } else {
        toast.error("Failed to fetch RFID data");
      }
    } catch (error) {
      console.error("RFID Fetch Error:", error);
      toast.error("Error connecting to RFID service");
    }
  };

  // Jab Checkbox toggle ho tab API call karein
  const handleToggleRFID = (e) => {
    const checked = e.target.checked;
    setShowRFID(checked);
    if (checked && rfidData.length === 0) {
      fetchRFIDData();
    }
  };

  // if (validStops.length === 0 && polylinePath.length === 0) {
  //   return (
  //     <Box sx={{ p: 2, textAlign: "center" }}>
  //       <Typography variant="h6" color="text.secondary">
  //         No route or stops to display.
  //       </Typography>
  //       <Button variant="contained" onClick={onBack} sx={{ mt: 2 }}>
  //         Back
  //       </Button>
  //     </Box>
  //   );
  // }

  return (
    <Box sx={{ p: 2, position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
      {isLoaded && (
        <>

          <Box sx={{
            position: "absolute",
            top: "25px",
            right: "80px",
            // zIndex: 10,
            zIndex: 1000,
            width: "350px"
          }}>
            <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
              {/* <input
                type="text"
                placeholder="Search location..."
                style={{
                  boxSizing: `border-box`,
                  border: `1px solid transparent`,
                  width: `100%`,
                  height: `40px`,
                  padding: `0 12px`,
                  borderRadius: `3px`,
                  boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                  fontSize: `14px`,
                  outline: `none`,
                  textOverflow: `ellipses`,
                }}
              /> */}
              <Box
                component="input"
                placeholder="Search location..."
                onKeyDown={handleSearchKeyDown}
                sx={{
                  boxSizing: `border-box`,
                  border: `1px solid #e0e0e0`,
                  width: `100%`,
                  height: `43px`,
                  padding: `0 12px`,
                  borderRadius: `4px`,
                  boxShadow: `0 2px 6px rgba(0, 0, 0, 0.1)`,
                  fontSize: `14px`,
                  outline: `none`,
                  textOverflow: `ellipses`,
                  // Placeholder color yahan se control hoga
                  "&::placeholder": {
                    color: "rgba(73, 72, 72, 0.4)", // Light color
                    fontWeight: 400
                  }
                }}
              />
            </Autocomplete>
          </Box>
          <Box sx={{ position: "absolute", top: "25px", left: "180px", zIndex: 1000, bgcolor: '#fff', p: 1, borderRadius: 2, boxShadow: 3 }}>
            <label style={{ fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              <input type="checkbox" checked={showRFID} onChange={handleToggleRFID} style={{ marginRight: '8px' }} />
              Show RFID
            </label>
          </Box>
          <Box sx={{ position: "absolute", top: "25px", left: "25px", zIndex: 1000 }}>
            <MDButton
              variant="contained"
              color="warning"
              onClick={() => setIsUploadModalOpen(true)}
              sx={{ color: '#fff', boxShadow: '0 2px 6px rgba(0,0,0,0.3)' }}
            >
              Upload Stops
            </MDButton>
          </Box>
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            onLoad={(map) => {
              mapRef.current = map;
              fitBoundsToContent();
            }}
            center={validStops.length > 0 ? undefined : { lat: 17.3850, lng: 78.4867 }}
            // zoom={10}
            zoom={validStops.length > 0 ? undefined : 12}
            onRightClick={handleMapRightClick}
            options={{
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: true, // Yeh option button dikhayega
              fullscreenControlOptions: {
                position: window.google.maps.ControlPosition.RIGHT_TOP, // Button ki jagah
              },
              zoomControl: true,
              gestureHandling: "greedy",
            }}
          >
            {visiblePolylinePath.length > 0 && (
              <Polyline
                path={visiblePolylinePath}
                options={{
                  strokeColor: "black",
                  strokeOpacity: 0.8,
                  strokeWeight: 4,
                }}
              />
            )}

            {/* {validStops.map((stop) => {
              const isPending = selectedJourney?.state === "INITIALIZED" && !activePolyline;
              // const isPending = selectedJourney?.state === "INITIALIZED" && !selectedJourney?.wayPointsPolyLine;

              const markerIcon = isPending
                ? stopMyMarker
                : stopMarker; // Default for normal

              return (

                <Marker
                  key={stop.filterId}
                  position={{ lat: stop.lat, lng: stop.lng }}
                  draggable
                  onDrag={handleDrag(stop.filterId)}
                  onDragEnd={handleDragEnd(stop.filterId)}
                  title={stop.name}
                  onClick={() => setActiveMarker(stop.filterId)}
                  icon={{
                    url: markerIcon,
                    scaledSize: new window.google.maps.Size(40, 40),
                  }}
                > */}
            {validStops.map((stop) => {
              const isPending = selectedJourney?.state === "INITIALIZED" && !activePolyline;
              const markerIcon = isPending ? stopMyMarker : stopMarker;

              // 1. CHECK KAREIN KI KYA YE HOVERED STOP HAI
              const isHovered = hoveredStopId === stop.filterId;

              // 2. HOVER HONE PAR SIZE BADA KAREIN (Normal: 40, Hover: 65)
              const markerSize = isHovered ? 40 : 30;

              return (
                <Marker
                  key={stop.filterId}
                  position={{ lat: stop.lat, lng: stop.lng }}
                  draggable
                  onDrag={handleDrag(stop.filterId)}
                  onDragEnd={handleDragEnd(stop.filterId)}
                  title={stop.name}
                  onClick={() => setActiveMarker(stop.filterId)}
                  icon={{
                    url: markerIcon,
                    // 3. YAHAN DYNAMIC SIZE PASS KAREIN
                    scaledSize: new window.google.maps.Size(markerSize, markerSize),
                  }}
                  // 4. HOVER HONE PAR Z-INDEX BADHA DEIN TAAKI MARKER UPAR DIKHE
                  zIndex={isHovered ? 1000 : 1}
                >
                  {activeMarker === stop.filterId && (
                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                      <div style={{ maxWidth: 220 }}>
                        <Typography variant="subtitle2">{stop.name}</Typography>
                        <Typography variant="caption" display="block">
                          Landmark: {stop.landmark}
                        </Typography>
                        <Typography variant="caption">
                          Passengers: {stop.passengerCount}
                        </Typography>
                      </div>
                    </InfoWindow>
                  )}
                </Marker>
              )
            })}

            {dragPreview && dragPreview.lat != null && dragPreview.lng != null && (
              <OverlayView
                position={dragPreview}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <SnapPreview position={dragPreview} />
              </OverlayView>
            )}

            {tempMarker && (
              <Marker
                position={tempMarker}
                icon={{
                  url: stopGreenMarker,
                  scaledSize: new window.google.maps.Size(40, 40),
                }}
                opacity={0.8}
              // animation={window.google.maps.Animation.BOUNCE}
              />
            )}

            {/* --- NEW: RFID MARKERS --- */}
            {showRFID && rfidData.map((item, index) => (
              <Marker
                key={`rfid-${index}`}
                position={{ lat: Number(item.latitude), lng: Number(item.longitude) }}
                onClick={() => setActiveRFID(item)}
                icon={{
                  url: rfidStopMarker, // Ya aapka customized @parking icon
                  scaledSize: new window.google.maps.Size(35, 35),
                }}
              >
                {activeRFID === item && (
                  <InfoWindow onCloseClick={() => setActiveRFID(null)}>
                    <div style={{ color: '#000' }}>
                      <Typography variant="subtitle2">{item.accountName || "Unknown"}</Typography>
                      <Typography variant="caption">Time: {item.accessTime}</Typography><br />
                      <Typography variant="caption">ID: {item.accessId}</Typography>
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            ))}
          </GoogleMap>

          {/* 4. YAHAN AAYEGA MODAL (DIALOG) JISMEIN UPLOAD & PROCESS BUTTON HAI */}
          <Dialog open={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Bulk Upload Stops to Map</DialogTitle>

            <DialogContent>
              <Box p={2}>
                <Typography variant="body2" mb={2}>
                  Download the template, add your stops with Latitude and Longitude, and upload it back.
                </Typography>

                <Button variant="contained" color="info" fullWidth onClick={handleDownloadTemplate} sx={{ mb: 3 }}>
                  Download Template (CSV)
                </Button>

                {selectedFile && (
                  <Typography variant="caption" color="success.main" sx={{ mt: 1, mb: 1, display: "block" }}>
                    Selected: {selectedFile.name}
                  </Typography>
                )}

                <input
                  type="file"
                  accept=".xlsx, .xls, .csv"
                  onChange={onUpload}
                  style={{ width: "100%", padding: "10px", border: "1px dashed #ccc", borderRadius: "4px" }}
                />
              </Box>
            </DialogContent>

            {/* YEH HAI WOH JAGAH JAHAN BUTTON DALNA HAI */}
            <DialogActions>
              <Button onClick={() => setIsUploadModalOpen(false)} color="inherit">
                Cancel
              </Button>

              {/* YAHAN DALNA HAI YEH BUTTON */}
              <Button
                onClick={handleUploadSubmit}
                variant="contained"
                color="info"
                disabled={!uploadedStopsList}
              >
                Upload & Process
              </Button>

            </DialogActions>
          </Dialog>
        </>
      )}
    </Box>
  );
};

export default EditStopMap;